import {PHASES} from "../../../constants/phases";
import {
  selectCurrentPlayer,
  selectGameResults,
  selectIsGameStarted,
  selectPhase
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {selectIsParallelSupplyPhase} from "../supply/parallelSupplySelectors";
import {selectHeaderOwnPlayerView} from "./selectHeaderOwnPlayerView";

/**
 * Ходящий соперник для плашки под его кружком в строке игроков шапки — или
 * null, если плашки нет. Плашка — только в строительстве и войне (в
 * снабжении ходят все сразу) и только когда ходящий — не тот, чьи ресурсы
 * уже показывает левая зона шапки (selectHeaderOwnPlayerView): так сами
 * собой отпадают свой ход и hot-seat — там левая зона и есть ходящий. У
 * зрителя (сетевого, записи матча, локального режима зрителя) левой зоны
 * нет — плашка всегда у ходящего.
 *
 * @param {Object} state
 * @param {boolean} [isSpectatorMode] локальный режим зрителя (проп матча)
 * @returns {Object|null} игрок из состояния матча
 */
export const selectHeaderActingPlayerBadgePlayer = (state, isSpectatorMode = false) => {
  const phase = selectPhase(state);
  if (phase !== PHASES.CONSTRUCTION && phase !== PHASES.WAR) {
    return null;
  }
  if (!selectIsGameStarted(state) || selectGameResults(state) || selectIsParallelSupplyPhase(state)) {
    return null;
  }

  const currentPlayer = selectCurrentPlayer(state);
  if (!currentPlayer) {
    return null;
  }

  const ownView = selectHeaderOwnPlayerView(state, isSpectatorMode);
  if (ownView && ownView.player.id === currentPlayer.id) {
    return null;
  }

  return currentPlayer;
};
